import React from 'react';
import { Product, useProductList } from './useProductsList';
import { useHistory } from 'react-router-dom';
import { useFields } from '../../../toolympus/components/schemed';
import { SimpleList } from '../../../toolympus/components/primitives';
import { Typography } from '@mui/material';
import { CreateProduct } from './CreateEventDialog';
import { ActionTriggerEditButton } from '../../../toolympus/components/Actions';
import { PaymentSettingsPopupButton } from './PaymentSettingsEditor';

interface Props {
  
}

export const ProductListPage = (props: Props) => {
  const data = useProductList();
  const history = useHistory();

  const fields = useFields({
    defaultFields: [
      "title",
      "is_active",
      "price",
      "created_at",
    ],
    blacklist: [
      "description",
    ],
    schema: data.schema,
    storageKey: "_pform_productlist",
    extraSettings: {
      created_at: { utcToLocal: true, formatAsDate: true },
      updated_at: { utcToLocal: true, formatAsDate: true },
      published_at: { utcToLocal: true, formatAsDate: true },
      actualized_at: { utcToLocal: true, formatAsDate: true },
    }
  });

  return (<>
    <SimpleList
      data={{
        ...data,
        filter: data.filter.filter,
        setFilter: data.filter.setFilter,
        create: () => { data.newRecord.startEditing(); return Promise.resolve({ _id: "" } as Product); }
      }}
      fields={[
      ]}
      schema={data.schema}
      getLinkValue={cr => `/products/${cr._id}`}
      linkFields={[ "_id", "title" ]}
      title="Products"
      searchAuto
      searchAutoFocus
      fieldSetings={fields}
      fieldFilters={data.filtering}
      sorting={data.sorting}
      tableProps={{
        tailAnchor: data.limitTrigger.pagingAnchor,
      }}
      headerActions={<>
        <Typography variant="caption" color="textSecondary">Products: {data.count.data.total_records}</Typography>

      </>}
      headerTailActions={<>
        {/* <PluggableDocumentationButton documentationKey="documents" /> */}
        <PaymentSettingsPopupButton />
        <ActionTriggerEditButton
          apiPath="/api/actions/trigger"
          triggers={[
            "paymentform.core.product-entities/submission",
            "paymentform.core.product-entities/payment",
          ]}
          />
      </>}
      />

    <CreateProduct
      {...data.newRecord}
      save={() => data.newRecord.save().then(cr => { history.push(`/products/${cr._id}`); return cr; })}
      schema={data.schema}
      />
  </>);
}
